export default __webpack_public_path__ + "static/media/195.2349ba0b.gif";